import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getTemplates: function ({parentId}) {
    const query = parentId ? `?parentFolder=${parentId}` : ''
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('templates' + query)
  },
  createTemplate: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('templates', template)
  },
  deleteTemplate: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('templates/' + id)
  },
  updateTemplate: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.put('templates/' + template.id, template)
  },
  searchTemplates: function ({keywords = '', parentId = '', page = 1, limit = 9999}) {
    const query = [`page=${page}`, `limit=${limit}`]
    if (keywords) query.push(`search=${keywords}`)
    if (parentId) query.push(`parentFolder=${parentId}`)
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get(`templates/search?${query.join('&')}`)
  },
  updatePosition: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('templates/updateposition', template)
  },
  updateParent: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('templates/updateparent', template)
  }
}



// WEBPACK FOOTER //
// ./src/api/Templates/api.js